import { Box, Divider, Typography } from "@mui/material";

interface FieldErrorProps {
  error?: string;
  show: boolean;
}

const FieldError = ({ error, show }: FieldErrorProps) => {
  if (!error || !show) return null;

  return (
    <Box textAlign="left" width="100%">
      <Divider sx={{ mt: 1, bgcolor: "error.main" }} />
      <Typography color="error" variant="caption">
        {error}
      </Typography>
    </Box>
  );
};

export default FieldError;
